import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/** Mint circle + rounded checkmark (flat success mark) */
function SuccessCircleCheckIcon() {
  return (
    <div
      className="mx-auto flex h-24 w-24 shrink-0 items-center justify-center rounded-full bg-[#DFF1E9]"
      aria-hidden="true"
    >
      <svg
        width="30"
        height="30"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="h-12 w-12"
      >
        <path
          d="M7 12.5l3.5 3.5L17.5 8"
          stroke="#119975"
          strokeWidth="2.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
}

export default function RegisterNewTestSuccessPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const selectedKit = location.state?.selectedKit || { id: '', name: '' };
  const recipient = location.state?.recipient || null;
  const displayBarcode = selectedKit?.id || '-';
  const displayTestType = selectedKit?.name || '-';
  const displayName =
    [recipient?.firstName, recipient?.lastName].filter(Boolean).join(' ').trim() || 'Onbekend';
  const displayEmail = recipient?.email || '-';

  return (
    <div className="min-h-screen bg-[#F9F5F2] px-4 py-8 md:py-12">
       <div className="max-w-3xl mx-auto mb-5">
        <h1 className="text-[#1E2426] font-libreBaskerville text-2xl md:text-3xl text-center">
        Testkit Registreren
        </h1>
      </div>
      
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-sm overflow-hidden border border-[#E5E8EA]">
        <div className="bg-[#119975] text-white px-6 md:px-7 py-4 md:py-5">
          <div className="flex col items-start justify-between gap-4">
            <div>
              <p className="font-poppins font-semibold text-xl md:text-2xl leading-tight text-white">
                {displayBarcode}
              </p>
              <p className="font-poppins font-semibold text-sm md:text-[15px] leading-snug text-white/90 mt-1">
                {displayTestType}
              </p>
            </div>
          </div>
        </div>
        <div className="px-6 md:px-7 pt-6 md:pt-7 pb-8 md:pb-10">
          <div className="grid grid-cols-[40px_1fr_40px] items-center">
            <button
              type="button"
              onClick={() => navigate('/register-new-test')}
              className="w-10 h-10 rounded-full border border-[#D9E0E6] text-[#64748B] flex items-center justify-center"
              aria-label="Terug"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  d="M10 3L5 8L10 13"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
            <SuccessCircleCheckIcon />
            <div />
          </div>

          <h1 className="mt-5 text-center text-[#1E2426] font-poppins font-semibold text-2xl md:text-3xl">
            Kit geregistreerd
          </h1>
          <p className="mt-2 text-center text-[#5F6870] font-poppins text-sm md:text-base leading-6">
            {displayBarcode} is geregistreerd op naam van {displayName}.
          </p>

          <div className="mt-6 mx-auto max-w-xl rounded-xl bg-[#F3F1EF] border border-[#ECE8E5] p-4">
            <div className="flex items-start gap-3">
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#DFF1E9]">
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                >
                  <rect
                    x="3.5"
                    y="5.5"
                    width="17"
                    height="13"
                    rx="2"
                    stroke="#0F7A5F"
                    strokeWidth="2"
                  />
                  <path
                    d="M8 10H16"
                    stroke="#0F7A5F"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                  <path
                    d="M8 14H11.5"
                    stroke="#0F7A5F"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
              </div>
              <div>
                <p className="text-[#1E2426] font-poppins font-semibold text-sm md:text-base">
                  E-mail verstuurd
                </p>
                <p className="text-[#7A838A] font-poppins text-sm">{displayEmail}</p>
              </div>
            </div>
            <p className="mt-3 text-[#6F7A82] font-poppins text-sm md:text-base leading-6">
            Zodra het lab jouw resultaten heeft verwerkt, ontvang je een e-mail en kun je alles terugvinden onder Testhistorie.
            </p>
          </div>

          {/* <div className="mt-7 border-t border-[#E5E7EB] pt-6">
            <p className="text-[#1E2426] font-poppins font-medium text-sm md:text-[14px] leading-5">
              Nog niet-geactiveerde kits
            </p>
            <div className="mt-4 space-y-3">
              {inactiveKits.map((kit) => (
                <div
                  key={kit.id}
                  className="w-full text-left rounded-2xl border border-[#D1D5DB] bg-white px-4 py-3.5 flex items-center justify-between gap-4"
                >
                  <div>
                    <p className="text-[#1E2426] font-poppins font-semibold text-[15px] md:text-base leading-5">
                      {kit.id}
                    </p>
                    <p className="text-[#6F7A82] font-poppins font-normal text-sm leading-5">
                      {kit.name}
                    </p>
                  </div>
                  <p className="text-[#8A8F94] font-poppins font-semibold text-sm leading-5 whitespace-nowrap">
                    Niet geactiveerd
                  </p>
                </div>
              ))}
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
}
